module.exports = __webpack_public_path__ + "img/lg_ring_y_c_0_1@2x.e37ba259.png";